<template>
  <div>
    <top-nav />
    <div class="container">
      <img class="bg-img"
           src="@/assets/images/bg_login.png" />
      <el-card class="login-form-layout">
        <div class="login-title">密码登录</div>
        <el-form autoComplete="on"
                 :model="loginForm"
                 :rules="loginRules"
                 ref="loginForm"
                 label-position="left">
          <el-form-item prop="username">
            <el-input name="username"
                      type="text"
                      v-model="loginForm.username"
                      autoComplete="on"
                      placeholder="请输入手机号/用户名">
              <span slot="prefix">
                <i class="el-icon-user-solid" />
                <el-divider direction="vertical"></el-divider>
              </span>
            </el-input>
          </el-form-item>
          <el-form-item prop="password">
            <el-input name="password"
                      :type="pwdType"
                      @keyup.enter.native="handleLogin"
                      v-model="loginForm.password"
                      autoComplete="on"
                      placeholder="请输入密码">
              <span slot="prefix">
                <svg-icon style="width: 14px;"
                          icon-class="password"></svg-icon>
                <el-divider direction="vertical"></el-divider>
              </span>
              <!-- <span slot="suffix"
                    @click="showPwd">
                <svg-icon icon-class="eye"></svg-icon>
              </span> -->
            </el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="danger"
                       style="width: 100%;"
                       :loading="loading"
                       @click.native.prevent="handleLogin">登录</el-button>
          </el-form-item>
          <el-link @click="forgetPwd">忘记密码</el-link>
          <el-link style="float: right;color:#ef6c00" @click="forgetSettle">立即注册</el-link>
          <div class="row">
            <a class="column"
               @click="qqLogin">
              <img src="@/assets/images/Lqq.png">
              <div>QQ</div>
            </a>
          </div>
        </el-form>
      </el-card>
    </div>
    <bottom-footer />
  </div>
</template>

<script>
import { setSupport, getSupport, setCookie, getCookie } from '@/utils/support'
import TopNav from './components/TopNav'
import BottomFooter from './components/BottomFooter'
import { setToken } from '@/utils/auth'

export default {
  name: 'login',
  components: {
    TopNav,
    BottomFooter
  },
  data () {
    const validateUsername = (rule, value, callback) => {
      if (!value) {
        callback(new Error('请输入正确的手机号/用户名'))
      } else {
        callback()
      }
    };
    const validatePass = (rule, value, callback) => {
      if (value.length < 3) {
        callback(new Error('密码不能小于3位'))
      } else {
        callback()
      }
    };
    return {
      loginForm: {
        type: 0,
        username: '',
        password: '',
      },
      loginRules: {
        username: [{ required: true, trigger: 'blur', validator: validateUsername }],
        password: [{ required: true, trigger: 'blur', validator: validatePass }]
      },
      loading: false,
      pwdType: 'password'
    }
  },
  created () {
    let username = getCookie("username")
    let password = getCookie("password")
    if (username) {
      this.loginForm.username = username
    }
    if (password) {
      this.loginForm.password = password
    }
    if (this.$route.query.t && !this.$route.query.t == undefined) {
      // 存在token需要进行获取供应商信息判断处理
      console.log("token",this.$route.query.t);
      setToken(this.$route.query.t)
      this.$store.commit('SET_TOKEN', this.$route.query.t)
      this.$store.dispatch('GetInfo').then(res => {
        if (res.data.isMcht || res.data.parentId) {
          this.$router.push('/')
        } else {
          //this.$router.push('/select')
          this.$router.push('/settle')
        }
      })
    }
  },
  methods: {
    showPwd () {
      if (this.pwdType === 'password') {
        this.pwdType = ''
      } else {
        this.pwdType = 'password'
      }
    },
    handleLogin () {
      this.$refs.loginForm.validate(valid => {
        if (valid) {
          this.loading = true
          this.$store.dispatch('Login', this.loginForm).then((isMcht) => {
            this.loading = false
            setCookie("username", this.loginForm.username, 15)
            //setCookie("password", this.loginForm.password, 15)
            if (isMcht) {
              this.$router.push('/')
            } else {
              this.$router.push('/settle')
            }
          }).catch(() => {
            this.loading = false
          })
        }
      })
    },
    // 手机登录
    handlePhoneSubmit(name) {
      this.$refs[name].validate((valid) => {
        if (valid) {
          getAccountByPhone(this.phoneValidate).then(res => {
            if (res.data && res.data.usernameList) {
              res.data.usernameList.forEach(item => {
                item.uuid = res.data.uuid
              })
              this.accountList = res.data.usernameList
            } else {
              this.accountList = []
            }
            if (this.accountList && this.accountList.length == 1) {
              // 只有一个账号的直接登录
              this.accountLogin(this.accountList[0])
            } else if (this.accountList && this.accountList.length > 1) {
              // 多于一个账号的需要弹窗选择登录账号
              this.showSelectDialog = true
            } else {
              // 此处是无账号数据
              this.$Message.warning('查无此账号，请先注册！')
            }
          }).catch(() => {
            this.$Messaage.warning('登录失败，请重试！')
          })
        }
      })
    },
    // qq登录
    qqLogin () {
      QC.Login.showPopup({
        appId: '101485130',
        redirectURI: 'https://supplier.cnxieku.com/#/bindPage'
      })
    },
    forgetPwd () {
      this.$router.push('/forget')
    },
    forgetSettle () {
      window.open('https://user.cnxieku.com/register')
    }
  }
}
</script>

<style scoped>
.container {
  position: relative;
  height: calc(100vh - 196px);
  min-height: 36.5vw;
  background-color: #b70b30;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-end;
}

.container .bg-img {
  position: absolute;
  z-index: 0;
  left: 4.5vw;
  bottom: 0;
  height: 32.87vw;
}

.login-form-layout {
  width: 320px;
  padding: 20px;
  z-index: 9;
  margin-right: 12.87vw;
}

.login-title {
  color: #e12d1a;
  font-size: 17px;
  font-weight: bold;
  margin-bottom: 20px;
}

.login-form-layout .el-input .el-divider {
  margin: 0;
}

.row {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  margin-top: 10px;
}

.row .column {
  text-align: center;
  font-size: 12px;
}
</style>



// WEBPACK FOOTER //
// src/views/login/index.vue